import { CorretJobRequest, ID, JobBase, WorkCorrectCause } from '@project/shared-types';
import { JobChangeCorrectAPI } from '../job/model/job.api';



export class CorrectService {




    static async correctJob(
        order_id: ID,
        job_id: ID,
        cause: WorkCorrectCause,
        comment: string
    ): Promise<JobBase | null> {
        try {
            const requestData = {
                order_id,
                job_id,
                correct: cause,
                comment,
            } as CorretJobRequest;
            const response = await JobChangeCorrectAPI(requestData);
            return response.job as JobBase;
        } catch (error) {
            return null;
        }
    };


}